import { render, staticRenderFns } from "./Ventes.vue?vue&type=template&id=7ad509a9&"
import script from "./Ventes.vue?vue&type=script&lang=js&"
export * from "./Ventes.vue?vue&type=script&lang=js&"
import style0 from "./Ventes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports